export const QUOTE_APP_BASE_URL = '/quote'
export const APPLICATION_NAME = 'BrokerTec Quote'
